




export default class MediaQueryListModel {









  constructor(type, name, mediaQuery, width) {
    this.type = type;
    this.name = name;
    this.mediaQuery = mediaQuery;

    if (width) {
      this.width = width;
    }
  }
}
